import { MessageCircle } from "lucide-react";
import { useScrollDeep } from "@/hooks/useScrollDeep";

const WHATSAPP_URL =
  "https://wa.me/918602265191?text=Hi%20Dynamic%20X%20Media%2C%20I%27d%20like%20to%20explore%20working%20together.";

export default function WhatsAppFAB() {
  const deep = useScrollDeep(0.45);
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-fab"
      className="group fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] transition-all duration-500 hover:scale-110"
      style={{
        backgroundColor: "#25D366",
        opacity: deep ? 0 : 1,
        pointerEvents: deep ? "none" : "auto",
        transform: deep ? "translateY(20px) scale(0.85)" : "translateY(0) scale(1)",
      }}
    >
      <span
        aria-hidden
        className="absolute inset-0 rounded-full fab-pulse-ring"
        style={{ backgroundColor: "#25D366" }}
      />
      <MessageCircle className="relative h-6 w-6" strokeWidth={2} fill="white" />
      <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-md bg-black/90 px-3 py-1.5 text-xs font-medium text-white opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
        Chat on WhatsApp
      </span>
    </a>
  );
}
